const toLocalFormat = (price: number, local = 'tr-TR') =>
  (+price.toFixed(2)).toLocaleString(local);

export const getNumberParts = (price: number, local = 'tr-TR') => {
  const [whole = '0', decimals = '00'] = toLocalFormat(price, local).split(',');
  return [whole, decimals.padEnd(2, '0')];
};
